/* global modForm */
/**
 * Handles show/hide hvacFuelType block when hvacSystemType changes
 */
export function initHvacFuelTypeBlock() {
	// This checks whether selected hvac system type requires fuel type or not,
	// and shows or hides fuel type block
	const _check = function() {
		let hvacSystemType;

		if (modForm.opts.hvacSystemTypeField.length) {
			modForm.opts.hvacSystemTypeField.forEach(function(el) {
				if ('radio' === el.type) {
					hvacSystemType = el.checked && el.value.trim();
				} else {
					hvacSystemType = el.value.trim();
				}
			});
		}

		if (hvacSystemType) {
			if (modForm.opts.hvacSystemTypesWithFuel.indexOf(hvacSystemType) > -1) {
				modForm.opts.hvacFuelTypeBlock[0].style.display = 'block';
			} else {
				modForm.opts.hvacFuelTypeBlock[0].style.display = 'hidden';
			}
		}
	};

	if (modForm.opts.hvacSystemTypeField.length && modForm.opts.hvacFuelTypeBlock.length) {
		modForm.opts.hvacSystemTypeField.forEach(function(el) {
			el.addEventListener('change', function() {
				_check();
			});
		});

		_check();
	}
}
